<template>
  <div>
    <div v-if="errorMessage" class="alert-danger">
      {{ errorMessage }}
    </div>

    <div class="reservation-box-controls">
      <button v-if="backButtonText" class="back-button" type="button" @click="emit('return')">
        <BartoIcon icon="reservation-back-button-arrow" />

        <span>{{ backButtonText }}</span>
      </button>

      <button
        v-if="continueButtonText"
        type="button"
        class="btn-primary next-button"
        @click="emit('continue')"
      >
        {{ continueButtonText }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useErrorMessage } from '../modules/useErrorMessage';
import BartoIcon from './BartoIcon.vue';

const emit = defineEmits({
  continue: () => true,

  return: () => true,
});

defineProps({
  continueButtonText: String,
  backButtonText: String,
});

const { errorMessage } = useErrorMessage();
</script>
